angular.module('services.delivery.ReportsService', [
  'global'
])

/**
 * The ReportsService service stores methods used to access
 * system APIs.
 *
 * @class ReportsService
 * @constructor
 * @module services.delivery.ReportsService
 */
.factory('ReportsService', [
  '$sce',
  'ModelsService',
  'GLOBAL',
  '$q',
  function ($sce, ModelsService, GLOBAL, $q) {
    'use strict';

    var service = {

      /**
       * houses all cases built from reports
       *
       */
      reportedCases: [],

      /**
       * Returns reports.  If a reortId is
       * provided will return a single report.  If no
       * reortId is provided will return all cases.
       *
       * @param {string} [reortId] - param to return only a specific report
       * @return {Object|Array<Object>} All entries
       */
      get: function get(reortId) {
        service.reports = ModelsService.read('reports');

        if (reortId) {
          return _.find(service.reports, { id: reortId });
        }

        return service.reports;
      },

      /**
       * Method calculates point percentages.
       *
       * @param {number} earned - points earned
       * @param {number} total - total points available
       * @private
       */
      calcuatePercentage: function calcuatePercentage(earned, total) {
        return Math.round((earned / total) * 100) || 0;
      },

      /**
       * Method formats report date.
       *
       * @param {Date} stamp - timestamp to format
       * @private
       */
      formatDate: function formatDate(stamp) {
        return moment(stamp).format('dddd, MMMM Do YYYY');
      },

      /**
       * Method formats report timestamps.
       *
       * @param {Date} stamp - timestamp to format
       * @private
       */
      formatTime: function formatTime(stamp) {
        return moment(stamp).format('h:mm:ss a');
      },

      /**
       * Format a duration of time
       *
       * @param {number} m - minutes
       * @param {number} s - seconds
       */
      formatDuration: function (m, s) {
        var minutes = m;
        var seconds = s;

        if (minutes < 10) {
          minutes = '0' + minutes;
        }

        if (seconds < 10) {
          seconds = '0' + seconds;
        }

        return minutes + ':' + seconds;
      },

      /**
       * Method formats percentage for display in reports list.
       *
       * @param {Object} model - model to extract percentage from
       * @private
       */
      formatReportsListPercentage: function formatReportsListPercentage(model) {
        var earned = 0;
        var total = 0;
        var percentage = 0;

        // Loop through reports, calculate and format score percentage.
        _.forEach(model, function (obj) {
          earned = obj.content.points.earned;
          total = obj.content.points.total;
          percentage = service.calcuatePercentage(earned, total);

          // Update model with the data.
          obj.content.points.percentage = percentage;
        });

        return model;
      },

      /**
       * Method formats timestamps for display in report summary.
       *
       * @param {Object} model - model to extract timestamps from
       * @private
       */
      formatSummaryDateAndTime: function formatSummaryDateAndTime(model) {
        var startTime = 0;
        var endTime = 0;
        var duration = 0;
        var formattedDuration = 0;
        var formatted = {};

        // Calculate case duration. Result is in miliseconds.
        startTime = moment(model.createdAt);
        endTime = moment(model.content.timing.end);
        duration = endTime.diff(startTime);
        formattedDuration = service
          .formatDuration(moment(duration).get('minutes'), moment(duration).get('seconds'));

        // Set formatted timestamps in the
        // timing.formatted object.
        formatted.start = service.formatTime(startTime);
        formatted.end = service.formatTime(endTime);
        formatted.duration = formattedDuration;
        formatted.dateComplete = service.formatDate(endTime);

        model.content.formattedTiming = formatted;

        return model;
      },

      /**
       * Method formats counts and totals for display.
       *
       * @param {Object} model - modal to generate summary for
       * @private
       */
      formatSummary: function formatSummary(model) {
        var pointsTotal;
        var pointsEarned;
        var pointsPercentage;

        // Create objects in the model.
        var summary = {
          total: {
            total: 0,
            knowledge: 0,
            action: 0,
            follow: 0
          },
          correct: {
            total: 0,
            knowledge: 0,
            action: 0,
            follow: 0
          },
          incorrect: {
            total: 0,
            knowledge: 0,
            action: 0,
            follow: 0
          },
          percentage: 0
        };

        // Exclude end event.
        var states = _.reject(model.content.events, 'content.end', true);

        // Count totals by incrementing matches from states array.
        _.forEach(states, function (obj) {
          if (obj.content.feedback.rule.content.decision.model === 'state.knowledgeDecision') {
            summary.total.knowledge += 1;
            if (obj.content.feedback.correct.isCorrect) {
              summary.correct.knowledge += 1;
            } else {
              summary.incorrect.knowledge += 1;
            }
          }
          if (obj.content.feedback.rule.content.decision.model === 'state.actionDecision') {
            summary.total.action += 1;
            if (obj.content.feedback.correct.isCorrect) {
              summary.correct.action += 1;
            } else {
              summary.incorrect.action += 1;
            }
          }
          if (obj.content.feedback.rule.content.decision.model === 'state.followUp') {
            summary.total.follow += 1;
            if (obj.content.feedback.correct.isCorrect) {
              summary.correct.follow += 1;
            } else {
              summary.incorrect.follow += 1;
            }
          }
        });

        // Update summary with counts.
        summary.total.total = summary.total.knowledge
          + summary.total.action
          + summary.total.follow;
        summary.correct.total = summary.correct.knowledge
          + summary.correct.action
          + summary.correct.follow;
        summary.incorrect.total = summary.incorrect.knowledge
          + summary.incorrect.action
          + summary.incorrect.follow;

        // Calculate percentage.
        pointsTotal = model.content.points.total;
        pointsEarned = model.content.points.earned;
        pointsPercentage = service.calcuatePercentage(pointsEarned, pointsTotal);
        summary.percentage = pointsPercentage;

        // Update model with summary data.
        model.content.summary = summary;

        // Return the model.
        return model;
      },


      /**
       * Method calculates and formats event duration.
       *
       * @param {Object} model - model to format events for
       * @private
       */
      formatEvents: function formatEvents(model) {
        var caseStart = 0;
        var submittedAt = 0;
        var duration = 0;
        var formattedDuration = 0;

        // Assign case start time.
        caseStart = moment(model.content.timing.start);

        // filter out non-decision events
        model.content.events = _.filter(model.content.events, function (event) {
          return _.matchesProperty('content.type', 'decision')(event)
            || _.property('content.sbar')(event)
            || _.property('content.studentNotes')(event);
        });

        // Loop through events
        _.forEach(model.content.events, function (obj) {
          // calculate and format duration.
          submittedAt = moment(obj.createdAt);
          duration = submittedAt.diff(caseStart);
          formattedDuration = service
            .formatDuration(moment(duration).get('minutes'), moment(duration).get('seconds'));

          // Update model with the data.
          obj.submittedAt = formattedDuration;

          // Allow HTML output of formatted stem.
          if (obj.content.scored) {
            if (_.isString(obj.content.decision.content.stem)) {
              obj.content.decision.content.stem = $sce
                .trustAsHtml(obj.content.decision.content.stem);
            }

            obj.content.choices = service
              .formatSelectedChoices(obj.content.choices, obj.content.decision.content.choices);
          }

          // set actual correctness of selected option(s)
          _.forEach(obj.content.choices, function (choice) {
            if (_.has(obj, 'content.feedback.rule.content.decision.choices')) {
              choice.correct = _.find(obj.content.feedback.rule.content.decision.choices, 'id', choice.id).correct;
            }
          });
        });

        return model;
      },

      /**
       * Formats the selected choices with full content based on a list
       * of all possible choices
       *
       * @param {Array<string>} selected - Array of selected choice ids
       * @param {Array<Object>} all - Array of choice content from the decision
       * @return {Array<Object>} Formatted array of selected choices
       */
      formatSelectedChoices: function formatSelectedChoices(selected, all) {
        var ret = [];

        if (_.isString(_.first(selected))) {
          _.forEach(all, function (choice) {
            if (_.includes(selected, choice.id)) {
              ret.push(choice);
            }
          });
        } else {
          ret = selected;
        }

        return ret;
      },

      /**
       * Removes unscored items from the list of decisions
       *
       * @param {Object} model - report model
       * @return {Object} updated model
       */
      rejectUnscored: function rejectUnscored(model) {
        // filter out items that are not scored
        model.content.events = _.filter(model.content.events, function (event) {
          // SBAR, student notes, and top level score are primary indicators
          return event.content.scored
            || event.content.sbar
            || event.content.studentNotes
            // if there is rule feedback, check feedback scoring as a fallback
            || (
              _.has(event.content, 'feedback.rule.content')
              && (
                event.content.feedback.rule.content.scored
                || event.content.feedback.rule.content.decision.scored
              )
            );
        });

        return model;
      },

      /**
       * Adds difficult decision feedback from students to the question that they were responding to
       *
       * @param {Object} model - report model
       * @return {Object} updated model
       */
      attachDifficultDecisionFeedback: function attachDifficultDecisionFeedback(model) {
        // get difficult decision feedback from student
        var difficultDecisions = _.filter(model.content.events, 'content.type', 'difficult-decision');

        // link the feedback to the question the student was answering
        _.forEach(difficultDecisions, function (decisionFeedback) {
          var associatedEvent = _.find(model.content.events, 'id', decisionFeedback.content.choices[0]);
          associatedEvent.content.feedback.difficultDecision = decisionFeedback;
        });

        return model;
      },

      /**
       * Method formats report data for display.
       *
       * @param {Object} model - model to format reports for
       * @private
       */
      formatReports: function formatReports(model) {
        var ret = model;
        ret = service.attachDifficultDecisionFeedback(model);
        ret = service.rejectUnscored(ret);
        ret = service.formatSummaryDateAndTime(ret);
        ret = service.formatSummary(ret);
        ret = service.formatEvents(ret);

        return ret;
      },

      /**
       * Method formats report list data for display.
       *
       * @param {Object} model - model to generate report list for
       * @private
       */
      formatReportsList: function formatReportsList(model) {
        return service.formatReportsListPercentage(model);
      },

      /**
       * Gets the durration of each report
       *
       * @param {Object} caseRecord - case object
       * @param {Object} report - report object
       * @private
       */
      processDuration: function processDuration(caseRecord, report) {
        var st;
        var et;
        var duration;
        var totalSeconds;
        // var seconds;

        if (report.content.timing.end) {
          st = moment(report.content.timing.start);
          et = moment(report.content.timing.end);
          duration = et.diff(st);
          totalSeconds = duration / 1000;

          // helpful commented code
          // console.log(moment.utc(duration).format("HH:mm:ss.SSS"));
          // minutes = moment(duration).get('minutes');
          // seconds = moment(duration).get('seconds');

          report.content.timing.duration = totalSeconds;
          caseRecord.under5minutes = totalSeconds < 300
          ? caseRecord.under5minutes + 1 : caseRecord.under5minutes;

          caseRecord.under10minutes = totalSeconds < 600
          ? caseRecord.under10minutes + 1 : caseRecord.under10minutes;
        }
      },

      /**
       * Gets all the cases within all reports
       * gathers stats on them all
       *
       * @private
       */
      getCases: function getCases() {
        service.reportedCases = [];
        _.forEach(ModelsService.read('reports'), function (report) {
          var found;
          var caseReport;

          found = _.find(service.reportedCases, { id: report.content.simulation.id });

          if (found) {
            caseReport = found;
            service.processDuration(found, report);
            found.reports.push(report);
          } else {
            caseReport = {
              label: report.content.simulation.title,
              id: report.content.simulation.id,
              under5minutes: 0,
              under10minutes: 0,
              reports: []
            };
            service.processDuration(caseReport, report);
            caseReport.reports.push(report);
            service.reportedCases.push(caseReport);
          }
        });

        _.forEach(service.reportedCases, function (c) {
          var sum = 0;
          var incomplete = 0;
          var complete = 0;
          var score = 0;

          _.forEach(c.reports, function (r) {
            if (r.content.timing.end) {
              sum += r.content.timing.duration;
              score += r.content.points.earned;
              complete += 1;
              if (!c.caseScoreAvailable) {
                c.caseScoreAvailable = r.content.points.total;
              }
            } else {
              incomplete += 1;
            }
          }, [sum, score]);

          c.incomplete = incomplete;
          c.complete = complete;

          c.caseScoreAverage = score / c.complete;

          if (sum === 0) {
            c.averageDuration = {
              minutes: 0,
              seconds: 0
            };
          } else {
            c.averageDuration = {
              totalSeconds: Math.floor((sum / c.complete)),
              minutes: Math.floor((sum / c.complete) / 60),
              seconds: Math.floor(sum / c.complete) > 59
              ? Math.floor(sum / c.complete) % 60
              : Math.floor(sum / c.complete)
            };
          }
        });

        return service.reportedCases;
      },

      /**
       * Gets the durration of each report
       *
       * @param {Object} currentCase - case object
       * @param {Object} reports - reports for the case
       * @param {Object} params - url paramters
       * @private
       */
      getCaseQuestions: function (currentCase, reports, params) {
        var squeue = [];
        var equeue = [];
        /* eslint-disable
        lodash/prefer-filter,
        lodash/prefer-map,
        lodash/matches-prop-shorthand,
        lodash/matches-shorthand */

        _.forEach(reports, function (report) {
          if (report.content.timing.end) {
            _.forEach(report.content.events, function (event) {
              equeue.push(ModelsService.get('events', GLOBAL.apiPath + '/events/' + event.id, {
                server: params.server,
                token: params.token
              }, 500000));
            });
          }
        });


        _.forEach(currentCase.relatives, function (state) {
          if (state.model === 'states') {
            squeue.push(ModelsService.get('states', GLOBAL.apiPath + '/states/' + state.id, {
              server: params.server,
              token: params.token
            }, 500000));
          }
        });

        return $q
          .all(squeue)
          .then(function (states) {
            var dqueue = [];
            _.forEach(states, function (state) {
              if (state.content.type === 'state.choiceDecision') {
                dqueue.push(ModelsService.get('rules', GLOBAL.apiPath + '/rules/' + state.content.rules[0], {
                  server: params.server,
                  token: params.token
                }, 500000));
              }
            });
            return $q
              .all(dqueue)
              .then(function (decisions) {
                currentCase.questions = [];
                return $q
                .all(equeue)
                .then(function (answers) {
                  _.forEach(decisions, function (q) {
                    var question = {
                      title: q.content.decision.stem,
                      maxAttempts: q.content.decision.maxAttempts,
                      correct: [],
                      incorrect: []
                    };

                    var state = _.filter(states, function (t) {
                      return t.content.rules[0] === q.id;
                    })[0];

                    var questionanswers = _.filter(answers, function (a) {
                      return a.content.stateId === state.id;
                    });

                    _.forEach(questionanswers, function (a) {
                      var user = _.find(reports, function (r) {
                        var usr;
                        if (r.content.user) {
                          usr = (r.content.user.id ===
                            a.userId
                            &&
                            r.id ===
                            a.content.reportId);
                        } else {
                          usr = (r.id ===
                            a.content.reportId);
                        }

                        return usr;
                      });
                      if (a.content.feedback !== null && a.content.feedback.correct.isCorrect) {
                        question.correct.push(user);
                      } else {
                        question.incorrect.push(user);
                      }
                    });

                    currentCase.questions.push(question);
                  });
                  return {};
                });
              });
          });
      }
    };

    return service;
  }
]);
